export const API_URL = import.meta.env.VITE_APP_API_URL
  ? import.meta.env.VITE_APP_API_URL
  : 'https://ventscape.herokuapp.com/';

export const MINIMUM_AGE = 13;
